import React from 'react';

export const CountriesPrefsSelector = ({ countriesPrefs, currentPrefId }) => {
  const countriesPrefSelect = countriesPrefs.map((countriesPref) => {
    return (
      <option value={countriesPref.id} key={countriesPref.id}>
        {countriesPref.name}
      </option>
    );
  });

  const updatePrefId = async (prefId) => {
    try {
      const headers = new Headers();
      headers.append('Content-Type', 'application/json');

      const response = await fetch('/api/user/set_pref_id', {
        method: 'POST',
        body: JSON.stringify({ pref_id_1: prefId }),
        headers,
      });

      if (!response.ok) {
        alert('都道府県の更新に失敗しました。');
      }
    } catch (e) {
      alert('通信に失敗しました。')
    }
  };

  return (
    <div className="pr-2026__group">
      <h2 className="pr-2026__group-title">お住まいの都道府県</h2>
      <p className="pr-2026__group-note">近くで開かれるイベントをおすすめします</p>
      <select
        className="pr-2026__select"
        onChange={(e) => updatePrefId(e.target.value)}
        defaultValue={currentPrefId ?? 13}
      >
        {countriesPrefSelect}
      </select>
    </div>
  );
};
